import { rem, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css, CSSResult, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import { AlertType, AlertTypes } from './alert.types';

export const tag = tagName('alert');

const alertTypeStyle = (alertType: AlertType) => {
  const selector = unsafeCSS(`[type=${alertType}]`);
  const iconClass = unsafeCSS(`.alert-icon-${alertType}`);
  const borderToken = {
    info: 'alert-info-border-default',
    success: 'alert-success-border-default',
    danger: 'alert-danger-border-default',
    error: 'alert-error-border-default',
    warning: 'alert-warning-border-default',
    neutral: 'alert-neutral-border-default',
  }[alertType];
  const foregroundToken = {
    info: 'status-info-foreground',
    success: 'status-success-foreground',
    danger: 'status-danger-foreground',
    error: 'status-danger-foreground',
    warning: 'status-warning-foreground',
    neutral: 'alert-neutral-foreground-default',
  }[alertType];

  return css`
    :host(${selector}) {
      border-color: ${token(borderToken)};
      :where(a-icon) {
        color: ${token(foregroundToken)};
      }
    }

    ${iconClass} {
      color: ${token(foregroundToken)};
    }
  `;
};

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    align-items: flex-start;
    background: ${token('background-tertiary')};
    border-inline-start: ${rem(2)} solid;
    border-radius: ${rem(0, 8, 8, 0)};
    box-sizing: border-box;
    color: ${token('text-primary')};
    display: flex;
    gap: ${spacing(150)};
    inline-size: 100%;
    justify-content: space-between;
    padding: ${spacing(150)};
  }

  :host([variant='inline']) {
    inline-size: max-content;
  }

  :where(a-icon) {
    font-size: ${rem(18)};
    margin-block-start: ${spacing(25)};
    min-inline-size: ${rem(20)};
    &::part(iconSvg) {
      &:where(.fa-primary) {
        fill: ${token('alert-icon-foreground-default')};
      }
    }
  }

  :where(span) {
    margin-inline-end: auto;
    padding-inline-end: ${spacing(100)};
  }

  :where(a-icon-button) {
    justify-self: flex-end;
    &::part(button) {
      min-block-size: ${rem(24)};
      min-inline-size: ${rem(24)};
    }
  }
`);

AlertTypes.forEach((type: AlertType) => styles.push(alertTypeStyle(type)));

export const alertStyles = styles;
